import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';

import clsx from 'clsx';

import api from '../../common/apiService';
import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Grid,
  Snackbar,
  Hidden,
  CircularProgress,
  TopBar,
  Typography
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

import { parseISO, format } from 'date-fns';
import { Toolbar, UsersList, Summary, DishSummary } from './components';
import config from '../../config/config.json';
import withAlert from '../../hoc/withAlert';

import {
  initPage,
  getRequestErrorsByPageSelector,
  getPageReadyByPageSelector
} from '../../store/api';

import {
  loadCheckin,
  getTicketCheckinUsers,
  checkCouponsByUserAndMeal,
  deleteCouponsByUserAndMeal
} from '../../store/ticket';

import { getMealSelector } from '../../store/meal';

const useStyles = makeStyles(theme => ({
  toolbar: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const Bar = props => {
  // Заберем из HOC нужные методы для показа алерта
  const {
    className,
    setSnackMessage,
    setSnackType,
    setOpenSnack,
    ...rest
  } = props;

  const classes = useStyles();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedMeal, setSelectedMeal] = useState(config.mealsId.bar);

  const [couponsCount, setCouponsCount] = useState({
    allcoupons: 0,
    allcouponsStaff: 0,
    allcouponsCustomers: 0,
    allcouponsChecked: 0,
    allcouponsCheckedStaff: 0,
    allcouponsCheckedCustomers: 0
  });

  const dispatch = useDispatch();

  const pageReady = useSelector(
    getPageReadyByPageSelector(props.location.pathname)
  );

  const mealData = useSelector(getMealSelector);
  const usersData = useSelector(getTicketCheckinUsers);


  useEffect(() => {
    const getData = async () => {
      await initPage(props.location.pathname, dispatch);
    };
    getData();
  }, [dispatch]);

  const [users, setUsers] = useState([]);

  useEffect(() => {
    setUsers(usersData);
  }, [usersData]);

  const addCheckedCoupon = (coupon, checkedCoupon) => {
    coupon.checkedCoupons.push(checkedCoupon);
  };
  const deleteCheckedCoupon = (coupon, checkedCouponId) => {
    coupon.checkedCoupons = _.filter(coupon.checkedCoupons, ch => {
      return ch.id != checkedCouponId;
    });
  };

  useEffect(() => {
    // Получим списки сессий и пользователей

    const getData = async () => {
      await dispatch(loadCheckin(selectedDate, selectedMeal));
    };

    if (pageReady) {
      getData();
    }
  }, [pageReady]);

  const handleDateChange = date => {
    setSelectedDate(date);
  };

  const handleMakeReport = async () => {
    // setUsers(getData());
    await dispatch(loadCheckin(selectedDate, selectedMeal));
  };

  const handleChange = async ({ userId, mealId, checked }) => {
    if (checked === false) {
      await dispatch(checkCouponsByUserAndMeal(userId, selectedDate, mealId));
    } else {
      await dispatch(deleteCouponsByUserAndMeal(userId, selectedDate, mealId));
    }
  };

  const [couponStateFilter, setCouponStateFilter] = React.useState(() => 1);

  const handleCouponStateFilter = state => {
    setCouponStateFilter(state);
  };

  return (
    <React.Fragment>
      {pageReady === false && (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <CircularProgress disableShrink size={56} />
        </div>
      )}

      <div className={classes.toolbar}>
        <Toolbar
          date={selectedDate}
          meal={selectedMeal}
          onDateChange={handleDateChange}
          onMakeReport={handleMakeReport}
          onCouponStateFilter={handleCouponStateFilter}
          couponStateFilter={couponStateFilter}
          id={'toolbar'}
        />
        <div className={classes.content}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="flex-start"
            spacing={2}>
              
            <Hidden smUp>
              <Grid item sm={6} xs={12}>
                <DishSummary />
              </Grid>
            </Hidden>
 

            <Grid item sm={6} xs={12}>
              {pageReady !== false && users && users.length > 0 && (
                <UsersList
                  users={users}
                  onChange={handleChange}
                  couponStateFilter={couponStateFilter}
                />
              )}
            </Grid>

          </Grid>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withAlert(Bar);
